<template>
  <div class="auth-container">
    <video autoplay muted loop id="bgVideo">
      <source src="/img/pexels-dean-diemert-7961821_1_1.mp4" type="video/mp4">
    </video>
    <div class="login-view">
      <div class="login-form">
        <div class="login-form-inputs">
          <input v-model="username" :placeholder="$t('security.username')"/>
          <input v-model="password" type="password" :placeholder="$t('security.password')" @keyup.enter="login"/>
          <simple-button @press="login">{{ $t("security.login") }}</simple-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleButton from "../components/button/SimpleButton";

export default {
  name: "AuthView",
  components: {SimpleButton},
  data: function () {
    return {
      username: "",
      password: ""
    }

  },
  methods: {
    async login() {
      try {
        let logged = await this.$store.dispatch("auth/AUTHENTICATE", {username: this.username, password: this.password})
        if (logged.status != 200) {
          this.$notify({
            group: 'application',
            title: 'Login failed',
            text: `Login failed for this combination of username and password`,
            type: "error",
          })
        }else {
          this.$notify({
            group: 'application',
            title: 'Logged successfully',
            text: `You have been logged successfully`,
            type: "ok",
          })
        }
      } catch (exception) {
        this.$notify({
          group: 'application',
          title: 'Login failed',
          text: `Login failed due to unexpected application error `,
          type: "error"
        })
      }
    }
  },
  mounted() {
    document.querySelector('#bgVideo').playbackRate = 0.75;
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/global";

#bgVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: 1;
  opacity: 0.5;
}


.openRed {
  display: contents;
  font-style: normal;
  color: #CE252E;
}

.login-form {
  display: flex;
  padding: 2em;
  background-color: $backgroundColor;
  box-shadow: 0px 0px 20px darken($backgroundColor, 5);
  flex-flow: column;
  border-radius: 5px;
}

.login-form-inputs {
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  gap: 2em;
}

input {
  color: white;
  background: none;
  border: transparent;
  outline: none;
  border-bottom: 1px solid white;
  font-family: Poppins;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  //border: 1px solid green;
  -webkit-text-fill-color: white;
  -webkit-box-shadow: 0 0 0px 1000px #00000000 inset;
  transition: background-color 60000s ease-in-out 0s;
}

.ot-logo {
  width: 512px;
  margin: 20px;
}

.ls-logo {
  width: 32px;
}


.auth-container {
  display: grid;
  grid-template: 1fr / 3fr 6fr;
  width: 100vw;
  height: 100vh;
}

.livesystems {
  position: absolute;
  bottom: 0.5em;
  right: 0.5em;
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 0.5em;
  font-size: 1.5em;
  color: #FFFFFF;
}

.login-messages-view {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  background-color: #00000033;
  color: var(--card-font-color);
  font-size: 2em;
}

.login-view {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 0 0;
  margin: 0 0;
  user-select: none;
  z-index: 100;
}

.content-box {
  font-size: 1.25em;
  color: var(--card-font-color);
  display: flex;
  flex-flow: column;
  width: 100%;
  padding: 2em;
}
</style>
